<po-page-default p-title="Fichas de empregados" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
        <span class="an an-users"></span>
        Importação de fichas (DP)
      </span>

      <div class="po-lg-11 po-md-9 po-sm-8 po-mb-5 destaque">
        <p class="po-font-text-large po-mb-1">
          Envie um ou mais PDFs de ficha de empregados. Cada PDF é enviado ao Domínio separadamente, com os
          funcionários daquele arquivo, para atualização dos funcionários.
        </p>
        <p>
          <b>
            &nbsp;&nbsp; - Formatos aceitos: PDF (até 50 MB) ou uma pasta compactada em .zip com os PDFs em qualquer
            subpasta.
          </b>
        </p>
        <p><b>&nbsp;&nbsp; - É possível selecionar quantos PDFs quiser de uma vez.</b></p>
        <p>
          <b>
            &nbsp;&nbsp; - Com "Enviar pasta" ligado, selecione uma pasta com uma subpasta por empresa: os PDFs de
            cada subpasta são enviados juntos, de qualquer sistema (Domínio, Contimatic, Glicério) e de ativos ou
            inativos. Arquivos que não são PDF ou .zip são ignorados.
          </b>
        </p>
        <p><b>&nbsp;&nbsp; - A empresa é identificada pelo CNPJ do documento.</b></p>
        <p>
          <b>
            &nbsp;&nbsp; - Contimatic: a Ficha de Registro atualiza os dados pessoais e o Dados CTPS atualiza o
            histórico. O Dados CTPS não traz CPF, então o funcionário é localizado no Domínio pelo nome.
          </b>
        </p>
      </div>

      <po-switch
        class="po-lg-4 po-md-6 po-sm-12"
        name="modoPasta"
        p-label="Enviar pasta"
        p-label-on="Sim"
        p-label-off="Não"
        [(ngModel)]="modoPasta"
        [p-disabled]="loading"
        (p-change)="alternarModoPasta()">
      </po-switch>

      <!-- Pasta só pelo botão: arrastar pasta perde o caminho das subpastas e é limitado pelo navegador. -->
      <div class="po-lg-12">
        <po-upload
          #uploadPdf
          [p-restrictions]="pdfRestrictions"
          p-size="medium"
          [p-drag-drop]="!modoPasta"
          [p-multiple]="true"
          [p-directory]="modoPasta"
          [p-drag-drop-height]="150"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-label]="modoPasta ? 'Pasta com PDFs de fichas de empregados' : 'PDFs de fichas de empregados'">
        </po-upload>
      </div>

      <po-button
        class="po-lg-4 po-mt-3"
        p-icon="an an-paper-plane-tilt"
        p-label="Processar PDFs"
        (p-click)="importarPdfs()"
        [p-loading]="loading"
        [p-disabled]="loading">
      </po-button>

      <div class="po-lg-12 po-mt-4" *ngIf="showProgress">
        <div class="progress-section">
          <div class="progress-header">
            <i class="an an-timer"></i>
            <span>Progresso dos PDFs</span>
          </div>

          <div class="progress-body">
            <div class="status-row" *ngIf="inicioProcessamento">
              <div class="step-dot done"></div>
              <div>
                <p class="status-title">Início</p>
                <p class="status-desc">{{ inicioProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
              </div>
            </div>

            <div class="empresas-status-list" *ngIf="processos.length > 0">
              <div class="status-row" *ngFor="let item of processos">
                <div
                  class="step-dot"
                  [ngClass]="{
                    processing: item.status === 'PROCESSANDO',
                    done: item.status === 'PRONTO',
                    partial: item.status === 'PARCIAL',
                    blocked: item.status === 'BLOQUEADO'
                  }"></div>
                <div>
                  <p class="status-title">
                    <b>{{ item.nomeArquivo }}</b> — {{ getStatusLabel(item.status) }}
                    <span class="status-meta" *ngIf="item.layout"> ({{ item.layout }})</span>
                  </p>
                  <p class="status-desc">{{ item.mensagem }}</p>
                  <ul class="status-avisos" *ngIf="item.avisos?.length">
                    <li *ngFor="let aviso of item.avisos">{{ aviso }}</li>
                  </ul>
                  <p class="status-meta" *ngIf="item.razaoSocial || item.cnpj">
                    {{ item.razaoSocial }}
                    <span *ngIf="item.cnpj"> · CNPJ {{ item.cnpj }}</span>
                    <span *ngIf="item.codDominio != null"> · Domínio {{ item.codDominio }}</span>
                  </p>
                  <p class="status-meta" *ngIf="item.requestId">RequestId: {{ item.requestId }}</p>
                </div>
              </div>
            </div>

            <div class="status-row" *ngIf="fimProcessamento">
              <div class="step-dot done"></div>
              <div>
                <p class="status-title">Finalizado</p>
                <p class="status-desc">{{ fimProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </po-container>
  </div>
</po-page-default>
